module.exports = __webpack_public_path__ + "img/home.ee295c4a.svg";